import rule_center from "./rule_center"

export default {
    ...rule_center
}